<template>
  <div class="main-wrapper">

    <div class="gif-screen">
      <img class="gif" :src="currGif" alt="">
    </div>

    <transition name="homeGif">
      <img v-show="homeGifIsShown" class="gif home" src="/static/gifs/home.gif" alt="">
    </transition>

    <!-- <div class="preload">
      <img class="gif" src="/static/gifs/musicin.gif" alt="">
      <img class="gif" src="/static/gifs/musicout.gif" alt="">
      <img class="gif" src="/static/gifs/videoin.gif" alt="">
      <img class="gif" src="/static/gifs/videoout.gif" alt="">
      <img class="gif" src="/static/gifs/gigsin.gif" alt="">
      <img class="gif" src="/static/gifs/gigsout.gif" alt="">
      <img class="gif" src="/static/gifs/ilhemin.gif" alt="">
      <img class="gif" src="/static/gifs/ilhemout.gif" alt="">
    </div> -->


    <transition name="nav">
      <nav :class="$mq" v-if="navIsShown">
        <router-link to="music" class="nav-item music" :class="$mq">
          <span>music</span>
        </router-link>
        <div @click="changeGif('videoIN')" class="nav-item video" :class="$mq">
          <span>video</span>
        </div>
        <a target="_blank" href="http://facebook.com/ilhemkhodja" class="icon share fb" :class="$mq">
          <Fb></Fb>
        </a>
        <div @click="changeGif('gigsIN')" class="nav-item gigs" :class="$mq">
          <span>gigs</span>
        </div>
        <div @click="showMail()" class="icon share mail" :class="$mq">
          <Mail></Mail>
        </div>
        <div v-show="mailIsShown" class="pop-up-mail" >
          <span :class="$mq">music@ilhem.com</span>
        </div>
        <div @click="changeGif('ilhemIN')" class="nav-item ilhem" :class="$mq">
          <span>ilhem</span>
        </div>
      </nav>
    </transition>

    <router-view></router-view>

  </div>
</template>

<script>
import {bus} from '../main'

import Fb from '../assets/icons/fb.svg'
import Mail from '../assets/icons/mail.svg'
import Close from '../assets/icons/close.svg'
import Nav from '../components/Nav'

export default {
  name: 'Home',
  data () {
    return {
      a: '/static/gifs/home.gif',
      b: '/static/gifs/musicin.gif',
      c: '/static/gifs/musicout.gif',
      d: '/static/gifs/videoin.gif',
      e: '/static/gifs/videoout.gif',
      f: '/static/gifs/gigsin.gif',
      g: '/static/gifs/gigsout.gif',
      h: '/static/gifs/ilhemin.gif',
      i: '/static/gifs/ilhemout.gif',
      currGif: '',
      homeGifIsShown: true,
      navIsShown: true,
      mailIsShown: false,
    }
  },
  components: {
    Nav,
    Fb,
    Close,
    Mail
  },
  methods: {
    destroyTitle($event) {
      console.log('titleclose')
      console.log(event.currentTarget)
      event.currentTarget.className = "active"
    },
    showMail() {
      console.log('show mail');
      this.mailIsShown = !this.mailIsShown;
    },
    changeGif(index) {
      // if(index === 'home'){
      //   this.currGif = this.a;
      // }
      // if(index === 'musicIN'){
      //   console.log('lunch music gif in')
      //   this.homeGifIsShown = false;
      //   this.currGif = this.b;
      //   bus.$emit('showMusic');
      //   // this.musicIsShown = true;
      //   this.navIsShown = false;
      //   // this.mailIsShown = false;
      // }
      // if(index === 'musicOUT'){
      //   var self = this;
      //   this.currGif = this.c;
      //   this.musicIsShown = false;
      //   this.navIsShown = true;
      //   this.reload();
      // }
      // if(index === 'videoIN'){
      //   this.currGif = this.d;
      //   this.videoIsShown = true;
      //   this.navIsShown = false;
      //   this.mailIsShown = false;
      //
      //   this.homeGifIsShown = false;
      // }
      // if(index === 'videoOUT'){
      //   var self = this;
      //   this.currGif = this.e;
      //   this.videoIsShown = false;
      //   this.navIsShown = true;
      //   this.reload();
      // }
      // if(index === 'gigsIN'){
      //   this.currGif = this.f;
      //   this.gigsIsShown = true;
      //   this.navIsShown = false;
      //   this.mailIsShown = false;
      //
      //   this.homeGifIsShown = false;
      // }
      // if(index === 'gigsOUT'){
      //   var self = this;
      //   this.currGif = this.g;
      //   this.gigsIsShown = false;
      //   this.navIsShown = true;
      //   this.reload();
      // }
      // if(index === 'ilhemIN'){
      //   this.currGif = this.h;
      //   this.ilhemIsShown = true;
      //   this.navIsShown = false;
      //   this.mailIsShown = false;
      //
      //   this.homeGifIsShown = false;
      // }
      // if(index === 'ilhemOUT'){
      //   var self = this;
      //   this.currGif = this.i;
      //   this.ilhemIsShown = false;
      //   this.navIsShown = true;
      //   this.reload();
      // }
    },
    reload() {
      setTimeout(() => {
          this.homeGifIsShown = true;
        }, 2000);
    }
  },
  mounted() {
    this.changeGif('home');
  },
  created() {
    // bus.$on('musicOut', (data) => {
    //   this.currGif = this.c;
    //   this.navIsShown = true;
    //   this.reload();
    // });
  },
  watch: {
    '$route' (to, from) {
      console.log(to.name);
      console.log(from.name);

      if(to.name == 'music') {
        this.homeGifIsShown = false;
        this.currGif = this.b;
        this.navIsShown = false;
      }

      if(from.name == 'music') {
        this.currGif = this.c;
        this.navIsShown = true;
        this.reload();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue